import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { enquireScreen } from 'enquire-js';
import Header from './Home/header/Header';
import Footer from './Home/footer/Footer1';
import Home from './Home';
import './CSS/style.css';

import { Footer10DataSource,} from './Home/footer/dataSource';
import ContactUs from "./aboutUs/ContactUs";
import IndustrySolutions from "./IndustrySolutions/IndustrySolutions";
import tell from "./Home/img/telephone.png";
import contactUsTel from "./Home/img/contactUsTel.png";
import headImg from "./Home/img/headImg.png";
import Mobile from "./Home/img/Mobile.png";
import { Icon, Row} from "antd";
import Product from "./product/Product";
import Education from "./IndustrySolutions/TwoLevelPage/Education";
import CustomerCase from "./Case/CustomerCase";

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});

const { location } = window;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,
            show: false,
            scrollTop:0,
            contactUsShow:'hidden',
        };
    }

    componentDidMount() {
        // 适配手机屏幕;
        enquireScreen((b) => {
            this.setState({ isMobile: !!b });
        });
        // if (location.port) {
            // 样式 build 时间在 200-300ms 之间;
        setTimeout(() => {
            this.setState({
                show: true,
            });
        }, 1000);
        // }
        this.getScroll()
    }

    componentWillUnmount() {
        sessionStorage.clear();
    }

    handleScrollTop() {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth',
        });
    }
    getScroll = () => {
        window.onscroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.setState({ scrollTop })
        }
    }
    onMouseOver = () =>{
        this.setState({contactUsShow:'visible'})
    }
    onMouseLeave = () =>{
        this.setState({contactUsShow:'hidden'})
    }
    render() {
        const { show, scrollTop, contactUsShow } = this.state;
        return (
            show && (
                <Router>
                    <Header scrollTop = {scrollTop}/>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/contactUs" component={ContactUs} />
                    <Route exact path="/industrySolutions" component={IndustrySolutions} />
                    <Route exact path="/product" component={Product} />
                    <Route exact path="/customerCase" component={CustomerCase} />
                    <Route exact path="/education" component={Education} />
                    <Footer dataSource={Footer10DataSource} isMobile={this.isMobile} />
                    <div className="contactUsRight" onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave}>
                        <Row type="flex" justify="center" align="middle" style={{paddingTop:5}}>
                            <img src={tell} alt="联系我们" width={30}/>
                        </Row>
                    </div>
                    <div
                        onClick={this.handleScrollTop}
                        style={{ display: scrollTop > 0 ? "block" : "none" }}
                        className="upToTop"
                    >
                        <Icon type="up" style={{fontSize: 40, color:'#ffffff'}} />
                    </div>
                    <div style={{
                        bottom:250,
                        right:60,
                        width:"auto",
                        height:"auto",
                        position: "fixed",
                        cursor: "pointer",
                        zIndex: 100,
                        boxShadow:'0 8px 32px -8px rgba(133,133,133,0.5)',
                        visibility:contactUsShow,
                        transition: 'all 0.3s',
                    }} onMouseOver={this.onMouseOver} onMouseLeave={this.onMouseLeave}>
                        <div style={{backgroundColor:'#10B6FF',padding:20, borderRadius: '6px 6px 0 0',color:'#fff'}}>
                            <Row type="flex" justify="space-between" align="middle">
                                <img src={headImg} alt="headImg" width={80}/>
                                <div>
                                    <p style={{fontSize:16}}>联系我们</p>
                                    <p style={{fontSize:16}}>您好，我们随时为您提供帮助</p>
                                </div>
                            </Row>
                        </div>
                        <div style={{padding:'20px 40px', backgroundColor:"#fff", borderRadius: ' 0 0 6px 6px',color:'#10B6FF'}}>
                            <Row type="flex" align="middle">
                                <img src={contactUsTel} alt="pic"/>
                                <Row>
                                    <b style={{fontSize: 16}}>致电米弘</b>
                                    <p style={{fontSize: 16}}>023-65392396</p>
                                </Row>
                            </Row>
                            <br/>
                            <Row type="flex" align="middle">
                                <img src={Mobile} alt="pic"/>
                                <Row>
                                    <b style={{fontSize: 16}}>手机联系</b>
                                    <p style={{fontSize: 16}}>13368396612(李老师)</p>
                                </Row>
                            </Row>
                        </div>
                    </div>
                </Router>
            )
        );
    }
}

export default App;
